import { Action } from 'redux-actions'
import { all, call, put, take, takeEvery, takeLatest } from 'redux-saga/effects'
import api from '../../../services/api.services'
import {
  CompanyId,
  CreateTeam$Request,
  DeleteTeams$Request,
  GetCompanyTeams$Request,
  GetDivisions$Request,
  LockTeams$Request,
  RenameTeam$Request,
  UnlockTeams$Request,
  UpdateTeamSettings$Request,
  UpdateDivisionCategorySettings$Request,
  AssignTeamsRandomly$Request,
  GenerateTeams$Request,
  GetDivisionCategories$Request,
  CreateDivisionCategory$Request,
  DeleteDivisionCategory$Request,
  UserId,
  DivisionCategoryId,
  DivisionId,
} from '../../../services/api.types'
import {
  createTeam,
  createTeamFail,
  createTeamSuccess,
  createGroupSuccess,
  deleteTeams,
  deleteTeamsFail,
  deleteTeamsSuccess,
  getCompanyTeams,
  getCompanyTeamsFail,
  getCompanyTeamsSuccess,
  /*getDivisionsDeprecated,
  getDivisionsFail,
  getDivisionsSuccess,*/
  lockTeams,
  lockTeamsFail,
  lockTeamsSuccess,
  renameTeam,
  renameTeamFail,
  renameTeamSuccess,
  unlockTeams,
  unlockTeamsFail,
  unlockTeamsSuccess,
  updateTeamSettings,
  updateTeamSettingsFail,
  updateTeamSettingsSuccess,
  updateDivisionCategorySettings,
  updateDivisionCategorySettingsFail,
  updateDivisionCategorySettingsSuccess,
  setUserCategoryDivision,
  setUserCategoryDivisionFail,
  setUserCategoryDivisionSuccess,
  assignTeamsRandomly,
  assignTeamsRandomlyFail,
  assignTeamsRandomlySuccess,
  generateTeams,
  generateTeamsSuccess,
  generateTeamsFail,
  getAssignRandomTeamsFilters,
  getAssignRandomTeamsFiltersSuccess,
  getAssignRandomTeamsFiltersFail,
  deleteTeamsLoading,
  createTeamLoading,
  getDivisionCategories,
  getDivisionCategoriesSuccess,
  getDivisionCategoriesFail,
  createDivisionCategory,
  createDivisionCategorySuccess,
  createDivisionCategoryFail,
  deleteDivisionCategory,
  deleteDivisionCategorySuccess,
  deleteDivisionCategoryFail,
  renameDivisionCategory,
  renameDivisionCategorySuccess,
  renameDivisionCategoryFail,
  setSelectedGroupId,
  setSelectedGroupIdForCompany,
} from './TeamManagementActions'
import { addNotification, clearNotification } from '../../../common/notifications/NotificationActions'
import { INotification } from '../../../common/notifications/NotificationReducers'
import { t } from 'ttag'
import { getWhoAmI, getWhoAmIFail, getWhoAmISuccess } from '../../../common/auth/authActions'
import {
  getCompanyDivisions,
  getCompanyDivisionsFail,
  getCompanyDivisionsSuccess,
} from '../../Settings/store/SettingsActions'
import { scrollToTop } from '../../../common/helpers/scroll'
import { getErrorMsg } from '../../../common/helpers/translations'
import { getCompanyUsers } from '../../UserManagement/store/UserManagementActions'
import { updateSuperAdminTargetCompanyInfo } from '../../SuperAdmin/store/SuperAdminActions'

// function* sagaGetCompanyTeams(action: Action<GetCompanyTeams$Request>) {
//   try {
//     const { companyTeams } = yield call(api.users.getCompanyTeams, action.payload)
//     yield put({ type: String(getCompanyTeamsSuccess), payload: companyTeams })
//   } catch (e: any) {
//     console.log('GetCompanyTeamsFailed: ', e)
//     yield put({ type: String(getCompanyTeamsFail) })
//   }
// }

/*function* sagaGetDivisions(action: Action<GetDivisions$Request>): Generator<any, void, any> {
  try {
    const response = yield call(api.users.getDivisions, action.payload)
    const divisions = response.data?.divisionDtos || response.divisionDtos || []
    yield put({
      type: String(getDivisionsSuccess),
      payload: {
        companyId: action.payload.companyId,
        //categoryId: action.payload.categoryId,
        groups: divisions,
      },
    })
  } catch (e: any) {
    yield put({ type: String(getDivisionsFail) })
  }
}*/

function* sagaCreateTeam(action: Action<CreateTeam$Request & { silentSuccess: boolean }>) {
  try {
    yield put({ type: String(clearNotification) })

    const { companyId, name, isUserCreated, lock, silentSuccess, groupId } = action.payload

    // Store the companyId for tracking which company is creating a team
    yield put({ type: String(createTeamLoading), payload: companyId })

    // Use CreateDivision endpoint if groupId is provided (not teams), otherwise use CreateTeam
    const { divisionId } = groupId
      ? yield call(api.users.createDivision, { companyId, name, isUserCreated, lock, categoryId: groupId })
      : yield call(api.users.createTeam, { companyId, name, isUserCreated, lock })

    // Load teams/groups again...
    // ... and wait until they are finished!
    yield put({ type: String(getWhoAmI) })
    yield take([String(getWhoAmISuccess), String(getWhoAmIFail)])

    // If creating a group (groupId provided), load groups for that category
    // Otherwise, load company teams
    //if (groupId) {
    yield put({ type: String(getCompanyDivisions), payload: { companyId } })
    /*yield put({ type: String(getDivisionsDeprecated), payload: { companyId } })
    yield take([String(getDivisionsSuccess), String(getDivisionsFail)])*/

    yield put({ type: String(createGroupSuccess), payload: divisionId })
    // } else {
    //   yield put({ type: String(getCompanyTeams), payload: { companyId } })
    //   yield take([String(getCompanyTeamsSuccess), String(getCompanyTeamsFail)])

    //   yield put({ type: String(createTeamSuccess), payload: divisionId })
    // }

    if (!silentSuccess) {
      const successfulTeamNotification: INotification = {
        type: 'success',
        content: groupId ? t`Group created successfully!` : t`Team created successfully!`,
      }
      yield put({ type: String(addNotification), payload: successfulTeamNotification })
    }
  } catch (e: any) {
    console.log('CreateTeamFail: ', e)
    yield put({ type: String(createTeamFail) })

    const msg = e.message
    const isGroup = !!action.payload.groupId
    let content = isGroup ? t`Group creation failed. Please try again!` : t`Team creation failed. Please try again!`
    if (msg === 'Another team already created') {
      content = t`You have already created another team. You can only create one team.`
    } else if (msg === 'Team with the same name already exists') {
      content = isGroup
        ? t`A group with the same name already exists. Please choose a different name.`
        : t`A team with the same name already exists. Please choose a different name.`
    } else if (msg === 'Division with the same name already exists') {
      content = isGroup
        ? t`A group with the same name already exists. Please choose a different name.`
        : t`A team with the same name already exists. Please choose a different name.`
    } else if (msg === 'Team selection is locked') {
      content = t`Your admin has disabled team selection.`
    }

    const errorNotification: INotification = {
      type: 'warning',
      content,
    }
    yield put({ type: String(addNotification), payload: errorNotification })
    scrollToTop()
  }
}

function* sagaRenameTeam(
  action: Action<RenameTeam$Request & { companyId: CompanyId; categoryId?: DivisionCategoryId }>,
) {
  try {
    const { divisionId, name } = action.payload
    yield call(api.users.renameTeam, { divisionId, name })
    yield put({ type: String(renameTeamSuccess) })

    // Re-fetch teams after rename
    const { companyId, categoryId } = action.payload

    //if (categoryId) {
    //yield put({ type: String(getDivisionsDeprecated), payload: { companyId } })
    yield put({ type: String(getCompanyDivisions), payload: { companyId } })
    // } else {
    //   yield put({ type: String(getCompanyTeams), payload: { companyId } })
    // }

    const successfulTeamNotification: INotification = {
      type: 'success',
      content: categoryId ? t`Group renamed successfully!` : t`Team renamed successfully!`,
    }
    yield put({ type: String(addNotification), payload: successfulTeamNotification })
  } catch (e: any) {
    console.log('RenameTeamFailed: ', e)
    yield put({ type: String(renameTeamFail) })

    const msg = e.message
    let content = t`Failed to rename team! Please try again or contact our support.`
    if (msg === 'Team with the same name already exists') {
      content = t`A team with the same name already exists. Please choose a different name.`
    }

    const errorNotification: INotification = {
      type: 'warning',
      content,
    }
    yield put({ type: String(addNotification), payload: errorNotification })
    scrollToTop()
  }
}

function* sagaDeleteTeams(
  action: Action<
    DeleteTeams$Request & { companyId?: CompanyId; silentSuccess: boolean; categoryId?: DivisionCategoryId }
  >,
) {
  try {
    const { companyId, categoryId } = action.payload
    // Use the companyId for tracking which company is being processed
    yield put({ type: String(deleteTeamsLoading), payload: companyId || null })

    const { divisionIds, silentSuccess } = action.payload
    yield call(api.users.deleteTeams, { divisionIds })

    // Load teams again...
    // ... and wait until they are finished!
    yield put({ type: String(getWhoAmI) })
    yield take([String(getWhoAmISuccess), String(getWhoAmIFail)])

    // if (categoryId) {
    //   // TODO
    // } else {
    //   yield put({ type: String(getCompanyDivisions) })
    //   yield take([String(getCompanyDivisionsSuccess), String(getCompanyDivisionsFail)])
    // }
    /*yield put({ type: String(getDivisionsDeprecated), payload: { companyId } })
    yield take([String(getDivisionsSuccess), String(getDivisionsFail)])*/
    yield put({ type: String(getCompanyDivisions), payload: { companyId } })

    yield put({ type: String(deleteTeamsSuccess), payload: action.payload.divisionIds })

    if (!silentSuccess) {
      const oneTeam = action.payload.divisionIds.length === 1
      const successfulTeamNotification: INotification = {
        type: 'success',
        content: categoryId
          ? oneTeam
            ? t`Team deleted successfully!`
            : t`Teams deleted successfully!`
          : oneTeam
            ? t`Team deleted successfully!`
            : t`Teams deleted successfully!`,
      }
      yield put({ type: String(addNotification), payload: successfulTeamNotification })
    }
  } catch (e: any) {
    console.log('DeleteTeamFailed: ', e)
    yield put({ type: String(deleteTeamsFail) })

    const failedTeamNotification: INotification = {
      type: 'warning',
      content: t`Failed to delete team(s)! Please try again or contact our support.`,
    }
    yield put({ type: String(addNotification), payload: failedTeamNotification })
    scrollToTop()
  } finally {
    // Reset loading state to null
    yield put({ type: String(deleteTeamsLoading), payload: null })
  }
}

function* sagaLockTeams(action: Action<DeleteTeams$Request>) {
  try {
    yield call(api.users.lockTeams, action.payload)
    yield put({ type: String(lockTeamsSuccess), payload: new Date().getTime() })

    const successfulTeamNotification: INotification = {
      type: 'success',
      content: t`Team(s) locked successfully!`,
    }
    yield put({ type: String(addNotification), payload: successfulTeamNotification })
  } catch (e: any) {
    console.log('LockTeamFailed: ', e)
    yield put({ type: String(lockTeamsFail) })

    const failedTeamNotification: INotification = {
      type: 'warning',
      content: t`Failed to lock team(s)! Please try again or contact our support.`,
    }
    yield put({ type: String(addNotification), payload: failedTeamNotification })
  }
}

function* sagaUnlockTeams(action: Action<DeleteTeams$Request>) {
  try {
    yield call(api.users.unlockTeams, action.payload)
    yield put({ type: String(unlockTeamsSuccess), payload: new Date().getTime() })

    const successfulTeamNotification: INotification = {
      type: 'success',
      content: t`Team(s) unlocked successfully!`,
    }
    yield put({ type: String(addNotification), payload: successfulTeamNotification })
  } catch (e: any) {
    console.log('UnlockTeamFailed: ', e)
    yield put({ type: String(unlockTeamsFail) })

    const failedTeamNotification: INotification = {
      type: 'warning',
      content: t`Failed to unlock team(s)! Please try again or contact our support.`,
    }
    yield put({ type: String(addNotification), payload: failedTeamNotification })
  }
}

function* sagaUpdateTeamSettings(action: Action<UpdateTeamSettings$Request>) {
  try {
    yield call(api.users.updateTeamSettings, action.payload)
    yield put({ type: String(updateTeamSettingsSuccess), payload: new Date().getTime() })

    // Keep super-admin target company state in sync so re-opening Settings
    // reflects the values just saved (whoAmI won't return this company).
    yield put(
      updateSuperAdminTargetCompanyInfo({
        divisionRequired: action.payload.divisionRequired,
        teamSelectionLocked: action.payload.teamSelectionLocked,
        teamSwitchingDisabled: action.payload.teamSwitchingDisabled,
        userCreatedTeams: action.payload.userCreatedTeams,
        minTeamSize: action.payload.minTeamSize,
        maxTeamSize: action.payload.maxTeamSize,
      }),
    )

    const successfulSettingsNotification: INotification = {
      type: 'success',
      content: t`Team settings saved successfully!`,
    }
    yield put({ type: String(addNotification), payload: successfulSettingsNotification })
  } catch (e: any) {
    console.log('UpdateTeamSettingsFailed: ', e)
    yield put({ type: String(updateTeamSettingsFail) })

    const failedSettingsNotification: INotification = {
      type: 'warning',
      content: t`Failed to save team settings! Please try again or contact our support.`,
    }
    yield put({ type: String(addNotification), payload: failedSettingsNotification })
  }
}

function* sagaUpdateDivisionCategorySettings(action: Action<UpdateDivisionCategorySettings$Request>) {
  try {
    yield call(api.users.updateDivisionCategorySettings, action.payload)
    yield put({ type: String(updateDivisionCategorySettingsSuccess), payload: new Date().getTime() })

    const successfulSettingsNotification: INotification = {
      type: 'success',
      content: t`Group type settings saved successfully!`,
    }
    yield put({ type: String(addNotification), payload: successfulSettingsNotification })
  } catch (e: any) {
    console.log('UpdateDivisionCategorySettingsFailed: ', e)
    yield put({ type: String(updateDivisionCategorySettingsFail), payload: new Date().getTime() })

    const failedSettingsNotification: INotification = {
      type: 'warning',
      content: t`Failed to save group type settings! Please try again or contact our support.`,
    }
    yield put({ type: String(addNotification), payload: failedSettingsNotification })
  }
}

function* sagaSetUserCategoryDivision(
  action: Action<{
    companyId: CompanyId
    userId: UserId
    categoryId: DivisionCategoryId
    divisionId: DivisionId | null
    isAdminView?: boolean
  }>,
) {
  try {
    // console.log('sagaSetUserCategoryDivision called with payload:', action.payload)
    yield call(api.users.setUserCategoryDivision, action.payload)
    // console.log('setUserCategoryDivision API call successful')

    // Trigger appropriate follow-up action based on context
    if (action.payload.isAdminView) {
      // If called from admin view, refresh company users
      yield put({ type: String(getCompanyUsers), payload: { companyId: action.payload.companyId } })
    } else {
      // If called from user settings view, refresh user profile
      yield put({ type: String(getWhoAmI) })
    }
    // And divisions
    yield put({ type: String(getCompanyDivisions), payload: { companyId: action.payload.companyId } })

    yield put({ type: String(setUserCategoryDivisionSuccess) })
  } catch (e: any) {
    console.log('SetUserCategoryDivisionFailed: ', e)
    yield put({ type: String(setUserCategoryDivisionFail) })

    const failedNotification: INotification = {
      type: 'warning',
      content: t`Failed to save group selection! Please try again or contact our support.`,
    }
    yield put({ type: String(addNotification), payload: failedNotification })
  }
}

function* sagaAssignTeamsRandomly(action: Action<AssignTeamsRandomly$Request>) {
  try {
    yield call(api.users.assignTeamsRandomly, action.payload)
    yield put({ type: String(assignTeamsRandomlySuccess) })

    // Re-fetch teams after assignment
    const { companyId } = action.payload
    //yield put({ type: String(getCompanyTeams), payload: { companyId } })
    //yield put({ type: String(getDivisionsDeprecated), payload: { companyId } })
    yield put({ type: String(getCompanyDivisions), payload: { companyId } })

    const successfulAssignmentNotification: INotification = {
      type: 'success',
      content: t`Teams successfully assigned at random!`,
    }
    yield put({ type: String(addNotification), payload: successfulAssignmentNotification })
  } catch (e: any) {
    console.log('AssignTeamsRandomlyFailed: ', e)
    yield put({ type: String(assignTeamsRandomlyFail) })

    const failedAssignmentNotification: INotification = {
      type: 'warning',
      content: t`Failed to assign teams randomly! Please try again or contact our support.`,
    }
    yield put({ type: String(addNotification), payload: failedAssignmentNotification })
  }
}

function* sagaGenerateTeams(action: Action<GenerateTeams$Request>) {
  try {
    const { generatedTeamIds } = yield call(api.users.generateTeams, action.payload)
    yield put({ type: String(generateTeamsSuccess), payload: generatedTeamIds })

    // Re-fetch teams after generation
    const { companyId } = action.payload
    //yield put({ type: String(getDivisionsDeprecated), payload: { companyId } })
    yield put({ type: String(getCompanyDivisions), payload: { companyId } })

    const x = action.payload.amount
    const successfulGenerationNotification: INotification = {
      type: 'success',
      content: x == 1 ? t`Successfully generated 1 teams!` : t`Successfully generated ${x} teams!`,
    }
    yield put({ type: String(addNotification), payload: successfulGenerationNotification })
  } catch (e: any) {
    console.log('GenerateTeamsFailed: ', e)
    yield put({ type: String(generateTeamsFail) })

    const failedGenerationNotification: INotification = {
      type: 'warning',
      content: t`Failed to generate teams! Please try again or contact our support.`,
    }
    yield put({ type: String(addNotification), payload: failedGenerationNotification })
  }
}

function* sagaGetAssignRandomTeamsFilters(action: any): Generator<any, void, any> {
  try {
    const payload = action.payload
    const response = yield call(api.users.getAssignRandomTeamsFilters, payload)
    yield put(getAssignRandomTeamsFiltersSuccess(response))
  } catch (e) {
    console.error('Error getting assign random teams filters', e)
    yield put(getAssignRandomTeamsFiltersFail())
  }
}

function* sagaGetDivisionCategories(action: Action<GetDivisionCategories$Request>): Generator<any, void, any> {
  try {
    const { categories } = yield call(api.users.getDivisionCategories, action.payload || {})
    yield put({ type: String(getDivisionCategoriesSuccess), payload: categories })
  } catch (e: any) {
    console.log('GetDivisionCategoriesFailed: ', e)
    yield put({ type: String(getDivisionCategoriesFail) })
  }
}

function* sagaCreateDivisionCategory(action: Action<CreateDivisionCategory$Request>): Generator<any, void, any> {
  try {
    const response = yield call(api.users.createDivisionCategory, action.payload)
    yield put({ type: String(createDivisionCategorySuccess), payload: response })

    // Set the newly created category as selected for the current company
    if (response && response.categoryId) {
      yield put({
        type: String(setSelectedGroupIdForCompany),
        payload: {
          companyId: action.payload.companyId,
          groupId: response.categoryId,
        },
      })
    }

    // Refresh categories after creating
    yield put(getDivisionCategories({ companyId: action.payload.companyId }))

    // Show success notification
    const successfulCategoryNotification: INotification = {
      type: 'success',
      content: t`Group type created successfully!`,
    }
    yield put({ type: String(addNotification), payload: successfulCategoryNotification })
  } catch (e: any) {
    console.log('CreateDivisionCategoryFailed: ', e)
    yield put({ type: String(createDivisionCategoryFail) })

    // Check for specific error message about duplicate category name
    let errorContent: string
    if (e.message && e.message.includes('Category with the same name already exists')) {
      errorContent = t`Group type with this name already exists. Please choose a different name.`
    } else {
      errorContent = t`Failed to create group type! Please try again or contact our support.`
    }

    // Show error notification
    const failedCategoryNotification: INotification = {
      type: 'warning',
      content: errorContent,
    }
    yield put({ type: String(addNotification), payload: failedCategoryNotification })
    scrollToTop()
  }
}

function* sagaDeleteDivisionCategory(action: Action<DeleteDivisionCategory$Request>): Generator<any, void, any> {
  try {
    const response = yield call(api.users.deleteDivisionCategory, action.payload)
    yield put({ type: String(deleteDivisionCategorySuccess), payload: response })
    // Refresh categories after deleting
    yield put(getDivisionCategories({ companyId: action.payload.companyId }))
  } catch (e: any) {
    console.log('DeleteDivisionCategoryFailed: ', e)
    yield put({ type: String(deleteDivisionCategoryFail) })
  }
}

function* sagaRenameDivisionCategory(
  action: Action<{ groupId: string; companyId: string; customName: string }>,
): Generator<any, void, any> {
  try {
    // For now, we'll just refresh the categories since there's no rename API
    // TODO: Implement actual rename API call when available
    yield put({ type: String(renameDivisionCategorySuccess), payload: action.payload })
    // Refresh categories after renaming
    yield put(getDivisionCategories({ companyId: action.payload.companyId }))
  } catch (e: any) {
    console.log('RenameDivisionCategoryFailed: ', e)
    yield put({ type: String(renameDivisionCategoryFail) })
  }
}

export function* teamManagementSagas() {
  yield all([
    //takeEvery(String(getCompanyTeams), sagaGetCompanyTeams),
    //takeEvery(String(getDivisionsDeprecated), sagaGetDivisions),
    takeEvery(String(createTeam), sagaCreateTeam),
    takeEvery(String(renameTeam), sagaRenameTeam),
    takeEvery(String(deleteTeams), sagaDeleteTeams),
    takeEvery(String(lockTeams), sagaLockTeams),
    takeEvery(String(unlockTeams), sagaUnlockTeams),
    takeEvery(String(updateTeamSettings), sagaUpdateTeamSettings),
    takeEvery(String(updateDivisionCategorySettings), sagaUpdateDivisionCategorySettings),
    takeEvery(String(setUserCategoryDivision), sagaSetUserCategoryDivision),
    takeEvery(String(assignTeamsRandomly), sagaAssignTeamsRandomly),
    takeEvery(String(generateTeams), sagaGenerateTeams),
    takeLatest(String(getAssignRandomTeamsFilters), sagaGetAssignRandomTeamsFilters),
    takeEvery(String(getDivisionCategories), sagaGetDivisionCategories),
    takeEvery(String(createDivisionCategory), sagaCreateDivisionCategory),
    takeEvery(String(deleteDivisionCategory), sagaDeleteDivisionCategory),
    takeEvery(String(renameDivisionCategory), sagaRenameDivisionCategory),
  ])
}
